export const FILTER_TOGGLE_ID = (modifier: string): string =>
  `products-filter__toggle--${modifier}`;
export const FILTER_TOGGLED = 'products-filter__toggle--toggled';
export const FILTER_ITEMS = (modifier: string): string =>
  `products-filter__item--values-${modifier}`;
export const FILTER_ITEMS_SHOW = 'products-filter__item--values-show';
export const FILTERS = 'products-filter__inner';
export const FILTERS_TOGGLED = 'products-filter__inner--toggled';
